import type {CustomerResponseBodyV2} from '@dms/api/customer';

import type {Nullish} from 'shared/web';

export const isCustomerNaturalPerson = (
  customer: Pick<CustomerResponseBodyV2, 'discriminator'> | Nullish
) => customer?.discriminator === 'NATURAL_PERSON';
